<template>
  <div>
    <v-row>
      <v-col cols="12" md="12" lg="12">
        <v-list-item-title style="text-align: left" class="font-weight-bold">{{ $tc("dashboard.menu.eventDetails.eventDescription") }}</v-list-item-title>
        <vue-editor v-model="eventDescription_"></vue-editor>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="1" md="1" lg="1">
        <v-btn class="ma-2" outlined @click="saveEventDescription()">{{ $tc("dashboard.menu.promoter_dashboard.save") }}</v-btn>
      </v-col>
      <v-col cols="11" md="11" lg="11" style="display: flex; justify-content: start; align-items: center; font-weight: bold">
        <span id="msg_description" style="margin-left: 10px; padding: 9px; color: green"></span>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" md="12" lg="12">
        <v-list-item-title style="text-align: left" class="font-weight-bold">{{ $tc("dashboard.menu.eventDetails.disclaimer") }}</v-list-item-title>
        <vue-editor v-model="disclaimer"></vue-editor>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="1" md="1" lg="1">
        <v-btn class="ma-2" outlined @click="saveDisclaimer()">{{ $tc("dashboard.menu.promoter_dashboard.save") }}</v-btn>
      </v-col>
      <v-col cols="11" md="11" lg="11" style="display: flex; justify-content: start; align-items: center; font-weight: bold">
        <span id="msg_disclaimer" style="margin-left: 10px; padding: 9px; color: green"></span>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { VueEditor } from "vue2-editor";
import { apiCalls } from "@/mixins/apiCalls.js";
import AsyncComputed from "vue-async-computed";
import Vue from "vue";

Vue.use(AsyncComputed);

export default {
  mixins: [apiCalls],
  components: {
    VueEditor,
  },
  props: ["response"],
  data() {
    return {
      eventDescription_: null,
      disclaimer: null,
    };
  },
  asyncComputed: {
    eventDescription_: async function () {
      //var response = await this.api("get", "/api/v1/users/current/promoter/eventDetails/getEvent/" + this.$route.params.id);
      var response = this.response;
      return response.message[0].eventDescription;
    },
    disclaimer: async function () {
      //var response = await this.api("get", "/api/v1/users/current/promoter/eventDetails/getEvent/" + this.$route.params.id);
      var response = this.response;
      return response.message[0].registrationDisclaimer;
    },
  },
  methods: {
    async saveEventDescription() {
      let data = {};

      data.eventDescription = this.eventDescription_;

      await this.postApi("/api/v1/promoter/eventDetails/updateEvent/" + this.$route.params.id, data);

      document.getElementById("msg_description").innerHTML = this.$t("dashboard.menu.eventDetails.msg_description");
      setTimeout(function () {
        document.getElementById("msg_description").innerHTML = "";
      }, 10000);
    },
    async saveDisclaimer() {
      let data = {};

      data.registrationDisclaimer = this.disclaimer;

      await this.postApi("/api/v1/promoter/eventDetails/updateEvent/" + this.$route.params.id, data);

      document.getElementById("msg_disclaimer").innerHTML = this.$t("dashboard.menu.eventDetails.msg_disclaimer");
      setTimeout(function () {
        document.getElementById("msg_disclaimer").innerHTML = "";
      }, 10000);
    },
  },
};
</script>
